const routes = {
  '/partner': {
    fetch: () =>
      import(
        /* webpackChunkName: 'partner-route' */ 'app/partner/asyncRoute'
      ).then(module => module.default),
  },
};

export default routes;
